import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import paths from './paths';
import DEFINES from '@/defines';

Vue.use (Router);

const router = new Router ({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {x: 0, y: 0};
    }
  },
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  routes: paths,
});

router.beforeEach (async (to, from, next) => {
  //which layout to use ?
  var oldLayout = store.getters['app/appLayout'];
  var newLayout = to.meta.layout || DEFINES.LAYOUT_GUEST;

  /**
   * 1. Change layout if navigating to different layout
   */
  if (newLayout != oldLayout) {
    store.dispatch (
      'app/setAppLayout',
      {
        layout: newLayout,
      },
      DEFINES.USE_ROOT
    );
  }

  /**
   * 2. If already logged in then navigate to company dashboard
   */
  if (to.name == 'company.login' && store.getters['app/isLoggedIn']) {
    return next ({
      name: 'company.dashboard',
    });
  }

  /**
   * 3. Ask for login if route is not allowed publicly
   */
  if (
    !store.getters['app/isLoggedIn'] &&
    to.matched.some (record => record.meta.public) != true
  ) {

    /**
     * If we already have any query from the last urls
     * then make sure passed to next route
     */
    let query = to.query;
    query.redirect =to.fullPath

    return next ({
      name: 'company.login',
      query
    });
  }


  /**
   * 6. Check of geo blocking
   */
  if (
    to.name == 'screeners.watch' &&
    store.getters['consumer/isScreeningGeoBlocked'] (to.params.screener_id) &&
    !store.getters['auth/isPreviewMode']
  ) {
    return next ({
      name: 'screeners.overview',
      params: {
        screener_id: to.params.screener_id,
      },
    });
  }

  /**
   * 6. check for embed
   */
  store.dispatch (
    'app/enableEmbedMode',
    {
      layout: newLayout,
      isEmbed: to.query && to.query.allowEmbed,
    },
    DEFINES.USE_ROOT
  );

  // Let user login to system if already logged in
  // if (
  //   (to.name == 'screeners.login' ||
  //     to.name == 'screeners.register' ||
  //     to.name == 'screeners.verify') &&
  //   store.getters['app/isLoggedIn'] &&
  //   store.getters['app/getAuthScreener'].id == to.params.screener_id
  // ) {
  //   return next({
  //     name: 'screeners.watch',
  //     params: {
  //       screener_id: to.params.screener_id,
  //     },
  //   });
  // }

  // Looking for affiliation in any route
  if(to.query && to.query.ref){
    store.dispatch (
      'affiliation/set',
      {
        code: to.query.ref
      },
      DEFINES.USE_ROOT
    );
  };


  next ();
});

export default router;
